@if (shouldRender()) {
<section class="featured-categories" aria-label="Categorías destacadas">
  <div class="featured-categories__inner">
    @for (panel of panels(); track panel.id) {
      <a class="featured-categories__panel" [routerLink]="panel.link">
        @if (panel.image) {
          <img
            class="featured-categories__image"
            [src]="panel.image"
            [alt]="panel.name"
            loading="lazy"
          />
        }
        <div class="featured-categories__overlay"></div>
        <div class="featured-categories__content">
          <h3 class="featured-categories__name">{{ panel.name }}</h3>
          <span class="featured-categories__cta">Explorar</span>
        </div>
      </a>
    }
  </div>
</section>
}
